import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      slidesCount: 4
    };
  },
  setup() {
    return {
      modules: [Pagination]
    };
  }
};